import { SxProps, Theme } from '@mui/system';

interface PropsType {
  style?: React.CSSProperties;
  color?: string;
  sx?: SxProps<Theme>;
}

const PolygonIcon = ({ sx }: PropsType) => {
  return (
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={sx as React.CSSProperties}>
      <path d="M9 6L0 11.1962L0 0.803848L9 6Z" fill="#E60012" />
    </svg>
  );
};

export default PolygonIcon;
